import Box from '@mui/material/Box';
import CheckIcon from '@mui/icons-material/Check';
import MDTypography from 'components/MDTypography';

/**
 * Visual stepper for CreateTripV2 (and reusable by other trip wizards).
 * Legacy CreateTrip.js keeps its own inline copy for rollback safety.
 */
const TripWizardStepper = ({
    steps,
    activeStep,
    completedSteps,
    onStepClick,
    allStepsClickable = false,
}) => (
    <Box sx={{ width: '100%', overflowX: 'auto', mt: 2.5, pt: 0.75, pb: 0.25 }}>
        <Box
            sx={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                minWidth: { xs: 640, md: '100%' },
                px: 0.5,
            }}
        >
            {steps.map((label, index) => {
                const isCompleted = completedSteps.has(index) && index < activeStep;
                const isActive = activeStep === index;
                const isPast = index < activeStep || isCompleted;
                const isFirst = index === 0;
                const isLast = index === steps.length - 1;
                const lineBeforeBright = !isFirst && index <= activeStep;
                const lineAfterBright = !isLast && isPast;
                const isClickable = allStepsClickable || isCompleted || index <= activeStep;

                return (
                    <Box
                        key={label}
                        onClick={() => isClickable && onStepClick?.(index)}
                        sx={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            minWidth: 56,
                            cursor: isClickable ? 'pointer' : 'default',
                            opacity: isClickable ? 1 : 0.6,
                        }}
                    >
                        <Box
                            sx={{
                                width: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Box
                                sx={{
                                    flex: 1,
                                    height: 2,
                                    bgcolor: lineBeforeBright ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.28)',
                                    mr: isFirst ? 0 : -0.25,
                                }}
                            />
                            <Box
                                sx={{
                                    width: 34,
                                    height: 34,
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '0.8rem',
                                    fontWeight: 700,
                                    lineHeight: 1,
                                    flexShrink: 0,
                                    position: 'relative',
                                    zIndex: 2,
                                    transition: 'all 0.2s ease',
                                    boxSizing: 'border-box',
                                    ...(isCompleted
                                        ? {
                                            bgcolor: '#2E7D32',
                                            color: '#fff',
                                            border: '2px solid #2E7D32',
                                        }
                                        : isActive
                                            ? {
                                                bgcolor: '#fff',
                                                color: '#1565C8',
                                                border: '2px solid #fff',
                                            }
                                            : {
                                                bgcolor: '#0E2348',
                                                color: '#fff',
                                                border: '2px solid rgba(255,255,255,0.65)',
                                            }),
                                }}
                            >
                                {isCompleted ? <CheckIcon sx={{ fontSize: 18 }} /> : index + 1}
                            </Box>
                            <Box
                                sx={{
                                    flex: 1,
                                    height: 2,
                                    bgcolor: lineAfterBright ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.28)',
                                    ml: isLast ? 0 : -0.25,
                                }}
                            />
                        </Box>
                        <MDTypography
                            variant="caption"
                            sx={{
                                mt: 1,
                                textAlign: 'center',
                                textTransform: 'uppercase',
                                fontSize: '0.62rem',
                                fontWeight: isActive ? 700 : 500,
                                letterSpacing: '0.05em',
                                color: isActive || isCompleted ? '#fff' : 'rgba(255,255,255,0.72)',
                                lineHeight: 1.25,
                                maxWidth: 72,
                            }}
                        >
                            {label}
                        </MDTypography>
                    </Box>
                );
            })}
        </Box>
    </Box>
);

export default TripWizardStepper;
